var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-user"},[_vm._v("\n    SERVICES\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }